import React from 'react'
import ProjectsBody from '../Components/ProjectsBody/ProjectsBody'
import Footer from '../Components/Footer/Footer'
import ChatBot from '../Components/Chat/ChatBot'
//import Chat from '../Components/Chat/Chat'

function Projects() {
    return (
        <>
        <ProjectsBody/>
        <Footer/>

        {/* <Chat/> */}
        {/* <ChatBot/> */}
        </>
    )
}

export default Projects
